module.exports = __webpack_public_path__ + "static/media/cable_tv.f4e41d94.svg";